import { takeEvery } from 'redux-saga'
import { fork, take, put, call, select } from 'redux-saga/effects'
import * as actions from './actions'
import _ from 'lodash'
import low from 'lowdb'
import categoryData from './reducers/categoryData'

import axios from 'axios'

const makeGet = (url) => axios.get(url).then(x => x.data)

const HOST = (() => {
  switch (process.env.NODE_ENV) {
    case 'production':
      return 'api.stock.selects.jp'
    case 'staging':
      return 'stg.api.stock.selects.jp'
    default:
      return 'localhost:8090'
  }
})()

const getItemsByCategory = (q, category, pfrom, pto) => makeGet(`http://${HOST}/items/search?category=${category}` +
                                                                (q ? `&q=${q}` : '') +
                                                                (pfrom && pto ? `&price-from=${pfrom}&price-to=${pto}` : ''));

const getFeature = (id, categoryId) => makeGet(`http://${HOST}/features/${id}` +
                                               (categoryId ? `?category=${categoryId}` : ''))

const getItem = (id) => makeGet(`http://${HOST}/items/${id}`)

function* fetchItems(action) {
  try {
    if (action.query.category) {
      const lastQuery = yield select(x => x.category.lastQuery)
      if (lastQuery && _.isEqual(lastQuery, action.query)) {
        yield put(actions.fetchItemsCancel())
      } else {
        const res = yield call(getItemsByCategory, action.query.q, action.query.category, action.query['price-from'], action.query['price-to'])
        yield put(actions.fetchItemsSucceed(res, action.query))
      }
    }
  } catch(e) {
    console.log(e.message, e.stack);
    yield put({
      type: actions.FETCH_ITEMS_FAILURE,
      error: e
    })
    ga('send', 'exception', {
      'exDescription': e.message,
    });
  }
}

function* handleToggleMyListItem(itemId) {
  while (true) {
    const action = yield take(TOGGLE_MYLIST_ITEM)
    const { payload, error } = yield call(fetchItem(category, query), action.payload)
  }
}

function* fetchFeature(action) {
  try {
    console.log('test', action)
    const res = yield call(getFeature, action.id, action.category)
    const scrollId = (new Date()).getTime()
    yield put({type : actions.FETCH_FEATURE_SUCCESS,
               feature: {...res,
                         scrollId: scrollId,
                         isWildCard: action.id.indexOf("wildcard") == 0,
                        }});
    const {itemId} = action;
    const items = itemId ?
          [_.find(res.items, {id: itemId}), ..._.filter(res.items, x => x.id != itemId)] :
          res.items
    yield put({
      type: actions.FETCH_FEATURE_ITEMS,
      items: items,
      scrollId,
    })
  } catch (e) {
    console.log(e.message, e.stack);
    yield put({
      type: actions.FETCH_FEATURE_FAILURE,
      error: e
    })
    ga('send', 'exception', {
      'exDescription': e.message,
    });
  }
}

const BATCH_SIZE = 16;
const PAGE_SIZE = 4;

function* fetchFeatureItems(action) {
  const batches = _.chunk(action.items, BATCH_SIZE);
  for (const k in batches) {
    yield put({type: actions.START_FETCH_FEATURE_ITEMS_PAGE})
    const batch = batches[k];
    var items = yield batch.map((item) => {
      return call(x => getItem(x).then(x => ({
        ...x,
        selects_order_id: item.order_id, // TODO: order_idと画像のひも付きを消しorder_idを上書きする
      })), item.id)
    })
    yield put(actions.fetchItemsSucceed(items, 'by-feature', k != 0))
    if (k % PAGE_SIZE == (PAGE_SIZE - 1)) {
      yield put({type: actions.WAIT_FETCH_FEATURE_ITEMS_PAGE})
      yield take(actions.LOAD_NEXT_PAGE_FEATURE_ITEMS);
      const currentScrollId = yield select(x => x.feature.scrollId)
      if (action.scrollId == currentScrollId) {
        console.log('load next')
      } else {
        console.log('break scroll loop')
        return
      }
    }
  }
  yield put({type: actions.ABORT_WAIT_FETCH_FEATURE_ITEMS_PAGE})
}

function* handleScrollBottomEvent() {
  const wait = createWaitForScrollBottom()
  while (true) {
    yield wait();
    yield put({
      type: actions.LOAD_NEXT_PAGE_FEATURE_ITEMS
    })
  }
}

function createWaitForScrollBottom() {
  let resolve = null;
  window.onscroll = function(ev) {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      // you're at the bottom of the page
      resolve()
    }
  }
  return () =>
    new Promise(function(_resolve, _reject){
      resolve = _resolve
    });
}

var scrollTopModalOpened

function* enableScroll(action) {
  if (action.enabled) {
    if (scrollTopModalOpened) {
      window.scrollTo(0, scrollTopModalOpened);
      scrollTopModalOpened = null
    }
  } else {
    scrollTopModalOpened = window.pageYOffset;
  }
}

export default function* rootSaga() {
  yield takeEvery(actions.FETCH_ITEMS, fetchItems)
  yield takeEvery(actions.FETCH_FEATURE, fetchFeature)
  yield takeEvery(actions.FETCH_FEATURE_ITEMS, fetchFeatureItems)
  yield takeEvery(actions.MODAL_ENABLE_SCROLL, enableScroll)
  yield fork(handleScrollBottomEvent)
  console.log('saga');
}



// WEBPACK FOOTER //
// ./src/sagas.js